import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentUser } from 'src/selectors/user-selectors';

import { setAccountMeta } from '../redux/actions/common';
import { getAccount } from '../redux/selectors/pipelines';

export const useAccount = () => {
  const dispatch = useDispatch();
  const account = useSelector(getAccount);
  const currentUser = useSelector(getCurrentUser);

  useEffect(() => {
    if (!account.hasFetchedUser && currentUser) {
      dispatch(
        setAccountMeta({
          accountId: currentUser.account_id || '',
          uuid: currentUser.uuid || '',
          userHas2FaEnabled: !!currentUser.has_2fa_enabled,
          name: currentUser.display_name,
          avatarSrc: currentUser.links?.avatar.href,
          hasFetchedUser: true,
        })
      );
    }
  }, [dispatch, currentUser, account.hasFetchedUser]);

  return account;
};
